// extracted by mini-css-extract-plugin
export default {"PeoplePage":"People_PeoplePage__ORsvz","CardsContainer":"People_CardsContainer__u5K6e","EmptyMessage":"People_EmptyMessage__13AA1","LoadingSpinner":"People_LoadingSpinner__0o+39"};